import {css} from 'lit';
export const styles = css`:host {
  display: block;
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background-color: var(--contrast-light);
  transition: background-color var(--transition-duration)
    var(--transition-timing);
}

:host([url]) {
  cursor: pointer;
  outline-offset: var(--link-focus-outline-offset);
}

:host([url]:focus) {
  outline: 1px solid var(--link-focus-outline);
}

@media (hover: hover) {
  :host([url]:hover) {
    --link-text-hover: var(--dark-text);
    --dot-menu-btn-bg: var(--gray-200);
    --dot-menu-btn-border-color: var(--gray-200);
    --dot-menu-btn-hover-bg: var(--gray-300);
    --dot-menu-btn-hover-border-color: var(--gray-300);

    background-color: var(--gray-200);
  }
}

:host([url]:active) {
  --link-text-active: var(--dark-text);

  background-color: var(--gray-300);
}

.main {
  display: flex;
  align-items: center;
}

.main a {
    display: block;
    outline: 0;
  }

.main .info,
  .main .actions {
    margin-left: 16px;
  }

.main .info {
    flex: 1;
    line-height: 1;
  }

ef-avatar {
  --avatar-size: 58px;

  position: relative;
  border: 1px solid var(--gray-new-100);
}

ef-avatar ef-online-status {
    --size: 18px;
    --border-size: 2px;
    --border: transparent;
    --background: transparent;
    --background-secondary: var(--green-700);
    --border-secondary: var(--contrast-light);

    position: absolute;
    display: block;
    top: -8px;
    right: -4px;
    z-index: 1;
  }

ef-avatar.my {
    outline: 2px solid var(--link-focus-outline);
    outline-offset: 2px;
  }

ef-avatar.my ef-online-status {
      --background-secondary: transparent;
      --border-secondary: transparent;
    }

.actions {
  display: flex;
  align-items: center;
}

::slotted([slot='title']) {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 16px;
  color: var(--dark-text);
}

::slotted([slot='info']) {
  margin-top: 4px;
  font-size: 14px;
  color: var(--dark-text-secondary);
}

::slotted([slot='actions']) {
  --link-focus-outline-offset: 0;
}

::slotted([slot='details']) {
  margin-top: 8px;
  color: var(--dark-text);
  font-size: 14px;
}
`;
export default styles;
